import React, { useState } from "react";
import WhiteBgCard from "../../WhiteBgCard";
import DormantCard from "./DormantCard";
import AccountsDashboardCommonHeader from "../freshIntentSignals/AccountsDashboardCommonHeader";
import SeeAllAccountsModal from "../AccountsDashboardSeeAllModal";
import BorderBottomCard from "../../BorderBottomCard";
import ShowDraftModal from "@/features/accounts/components/ShowDraftModal";

const Dormant = ({ accounts = [], reactivationAccounts = [], isLoading = false }) => {
  const [seeAllOpen, setSeeAllOpen] = useState(false);
  const [emailAccount, setEmailAccount] = useState(null);
  const allAccounts = [
    ...(accounts ?? []),
    ...(reactivationAccounts ?? []),
  ];
  const items = allAccounts.slice(0, 5);

  return (
    <WhiteBgCard className="p-4">
      <div className="flex flex-col gap-2.5">
        <AccountsDashboardCommonHeader
          title="Dormant (90d)"
          tooltipContent={
            <div className="space-y-1">
              <p>Dormant requires prior positive engagement and 90+ days of inactivity.</p>
              <p>Accounts with a new signal after a 90-day gap are shown as reactivation opportunities.</p>
            </div>
          }
          seeAllButtonText="See All"
          onSeeAll={() => setSeeAllOpen(true)}
        />
        <div className="max-h-[310px] w-full overflow-y-auto">
          {isLoading ? (
            <div className="flex flex-col w-full">
              {[1, 2, 3, 4, 5].map((i) => (
                <BorderBottomCard
                  key={i}
                  className="animate-pulse flex items-center justify-between gap-2"
                >
                  <div className="flex gap-2 items-center flex-1 min-w-0">
                    <div className="w-8 h-8 rounded-full bg-gray-200 shrink-0" />
                    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
                      <div className="h-3 w-24 rounded bg-gray-200" />
                      <div className="h-2.5 w-32 rounded bg-gray-200" />
                    </div>
                  </div>
                  <div className="h-6 w-16 rounded bg-gray-200 shrink-0" />
                </BorderBottomCard>
              ))}
            </div>
          ) : items.length === 0 ? (
            <p className="text-[0.8rem] text-gray-500 dark:text-gray-400 py-8 text-center min-h-[270px] w-full flex items-center justify-center">
              No dormant or reactivation accounts.
            </p>
          ) : (
            items.map((account, index) => (
              <DormantCard
                key={
                  account?.account_id ??
                  account?.company_name ??
                  `dormant-${index}`
                }
                account={account}
                onEmail={setEmailAccount}
              />
            ))
          )}
        </div>
      </div>
      <SeeAllAccountsModal
        isOpen={seeAllOpen}
        onClose={() => setSeeAllOpen(false)}
        variant="dormant"
        title="Dormant and reactivation accounts"
        description="Dormant accounts had prior positive engagement, then 90+ days of inactivity with no opportunity progression or recent buying signal."
        items={allAccounts}
      />
      <ShowDraftModal
        isOpen={Boolean(emailAccount)}
        onClose={() => setEmailAccount(null)}
        contact={
          emailAccount
            ? {
                relationship_mapping_id: emailAccount.relation_contact_id || null,
                person_name: emailAccount.contact_name,
                company_name: emailAccount.company_name,
              }
            : null
        }
      />
    </WhiteBgCard>
  );
};
export default Dormant;
